import React from 'react';
import styles from '../SelectPackage/SelectPackage.module.css';

type SelectPackageProps = {
  packages: string[];
  selectedPackage: number;
  onPackageSelect: (idx: number) => void;
};

const SelectPackage = ({
  packages,
  selectedPackage,
  onPackageSelect
}: SelectPackageProps) => {
  return (
    <div className={`${styles.hrPackageButtonRow} ${styles.scrollable}`}>
      <div
        className={`makeFlex perfectCenter ${styles.hrPackageButtonWrapper}`}
      >
        {packages.length > 0
          ? packages.map((packageString, idx) => (
              <div
                key={`${packageString}_${idx}`}
                className={`makeFlex perfectCenter ${styles.hrPackageButton} 
				${packages[selectedPackage] == packageString ? 'whiteText' : 'initial'} 
				  ${
            packages[selectedPackage] == packageString
              ? 'deepskyBlueBackGroundColor'
              : 'whiteBackGroundColor'
          }`}
                onClick={() => onPackageSelect(idx)}
              >
                {packageString}
              </div>
            ))
          : null}
      </div>
    </div>
  );
};
export default SelectPackage;
